<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function () {
    const accordionItems = document.querySelectorAll(".accordion-item");

    accordionItems.forEach(item => {
        const button = item.querySelector("button");
        const content = item.querySelector(".accordion-content");

        // Initially hide all
        content.style.maxHeight = "0px";
        content.style.overflow = "hidden";
        content.style.transition = "max-height 0.4s ease";

        button.addEventListener("click", function () {

            const isOpen = content.style.maxHeight !== "0px";

            // Close all
            accordionItems.forEach(i => {
                i.querySelector(".accordion-content").style.maxHeight = "0px";
                i.querySelector("button").setAttribute("aria-expanded", "false");
            });

            // Open clicked one (if it was closed)
            if (!isOpen) {
                content.style.maxHeight = content.scrollHeight + "px";
                button.setAttribute("aria-expanded", "true");
            }
        });
    });

});

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
